import React from "react";
import PropTypes from 'prop-types';
import styles from './input.module.css';

export const LinkedInput = ({ value, icon, label }) => {
    const handleNavigate = () => {
        window.open(value, '_blank');
    };
    return (
        <div className={styles.wrapper}>
            {label && <label className={styles.input_label}>{label}</label>}
            <div className={styles.split_input}>
                <div className={styles.linked_value}>{value}</div>
                <div className={styles.icon_wrapper} onClick={handleNavigate}>{icon}</div>
            </div>
        </div>
    );
}

LinkedInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.node,
}

export default LinkedInput;